import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import LevelIcon from './LevelIcon'
import StatusCountBar from './StatusCountBar'
import { NameContainer, TotalContainer } from './_Styled'
import Caption1 from '../typography/captions/Caption1'
import H3 from '../typography/headers/H3'
import P1 from '../typography/paragraphs/P1'
import { formatNumberForThreeDigits } from '../../utils/numbers'

const LevelWrapper = styled.li`
  display: flex;
  align-items: center;
  height: 70px;
  position: relative;
`

const StatusCountBarContainer = styled.div`
  position: absolute;
  right: 41px;
  top: 42px;
`

const StyledLevelNameContainer = styled(NameContainer)`
  align-items: center;
  flex: 0 0 209px;
  padding: 0 15px 0 38px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const StyledP1 = styled(P1)`
  padding-bottom: 22px;
`

const StyledTotalContainer = styled(TotalContainer)`
  margin-right: 18px;
  max-width: 63px;
`

const StyledCaption1 = styled(Caption1)`
  color: black;
  padding-left: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`

const DraftSubStatusCounts = styled(Caption1)`
  color: black;
  padding-bottom: 22px;
`

const Level = props => (
  <LevelWrapper>
    <StyledLevelNameContainer
      onClick={() =>
        props.clickHandler({
          course: props.course,
          level: props.level
        })
      }
    >
      <LevelIcon {...props} />
      <StyledCaption1>{props.level.name}</StyledCaption1>
    </StyledLevelNameContainer>

    <TotalContainer
      style={{ marginRight: '13px' }}
      onClick={() =>
        props.clickHandler({
          course: props.course,
          level: props.level
        })
      }
    >
      <H3>{formatNumberForThreeDigits(props.level.total_count)}</H3>
    </TotalContainer>

    <StyledTotalContainer
      onClick={() =>
        props.clickHandler({
          status: 'draft',
          course: props.course,
          level: props.level
        })
      }
    >
      <StyledP1>{formatNumberForThreeDigits(props.level.draft_count)}</StyledP1>
    </StyledTotalContainer>

    <StyledTotalContainer
      onClick={() =>
        props.clickHandler({
          status: 'exp/sub',
          course: props.course,
          level: props.level
        })
      }
    >
      <DraftSubStatusCounts>
        {formatNumberForThreeDigits(props.level.internal_review_count)}
      </DraftSubStatusCounts>
    </StyledTotalContainer>

    <StyledTotalContainer
      onClick={() =>
        props.clickHandler({
          status: 'copy edit',
          course: props.course,
          level: props.level
        })
      }
    >
      <DraftSubStatusCounts>
        {formatNumberForThreeDigits(props.level.copy_edit_count)}
      </DraftSubStatusCounts>
    </StyledTotalContainer>

    <StyledTotalContainer
      onClick={() =>
        props.clickHandler({
          status: 'review returned',
          course: props.course,
          level: props.level
        })
      }
      style={{ marginRight: '33px' }}
    >
      <StyledP1>
        {formatNumberForThreeDigits(props.level.rejected_count)}
      </StyledP1>
    </StyledTotalContainer>

    <StyledTotalContainer
      onClick={() =>
        props.clickHandler({
          status: 'quality review',
          course: props.course,
          level: props.level
        })
      }
      style={{ marginRight: '27px' }}
    >
      <StyledP1>
        {formatNumberForThreeDigits(props.level.quality_review_count)}
      </StyledP1>
    </StyledTotalContainer>

    <TotalContainer
      style={{ marginRight: '19px' }}
      onClick={() =>
        props.clickHandler({
          status: 'published',
          course: props.course,
          level: props.level
        })
      }
    >
      <StyledP1>
        {formatNumberForThreeDigits(props.level.published_count)}
      </StyledP1>
    </TotalContainer>
    <StatusCountBarContainer>
      <StatusCountBar
        draftCount={props.level.draft_count}
        rejectedCount={props.level.rejected_count}
        qualityReviewCount={props.level.quality_review_count}
        publishedCount={props.level.published_count}
        totalCount={props.level.total_count}
        width={460}
        height={7}
      />
    </StatusCountBarContainer>
  </LevelWrapper>
)

Level.propTypes = {
  level: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  course: PropTypes.object.isRequired,
  clickHandler: PropTypes.func.isRequired
}

export default Level



// WEBPACK FOOTER //
// ./src/components/productionstatus/Level.js